import React from 'react';
import './form2.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import bar2 from '../../../images/bar2.svg';
import upload from '../../../images/upload.svg';
import { Container, Form, Button, Row, Col, Image, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Form2() {
  
  const navigate = useNavigate()


  

  
  return (
    <Container fluid className='p-0 m-0'>
      <div className='d-flex align-items-center text-center  gap-4 py-5 px-3'>
      <FaArrowLeft className='arrow' onClick={() => navigate("/form1")} />
      <h3 className='mt-4'>Back</h3>
      </div>
      <Container fluid className='p-3 p-sm-5  align-items-center justify-content-center text-center' style={{ background: 'rgba(255, 161, 94, 0.55)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
        <div className='d-block align-items-center justify-content-center text-center py-3'>
        <Image fluid src={bar2} alt='bar' />
        <h2 className='form-head mt-4'>Resume Building</h2>
        </div>
        
          
          
          
          <Card className=' p-3 mb-3 mt-3 mt-sm-0 d-flex align-items-center justify-content-center text-center' style={{ background: '#D9D9D9'}}>
          <Form action="your-upload-handler.php" method="post" enctype="multipart/form-data" className='gap-3'>
          < Image src={upload} alt='cloud upload' className='' />
          <Form.Label for="file-upload" className='mb-3'>Select file or Drag here.</Form.Label>
          <Form.Control type="file" name="file" id="file-upload" className='mb-3' accept=".jpg,.jpeg,.png,.pdf" required/>
          <div className='align-items-center justify-content-center text-center'>
         <button type="submit" className='browse'>Browse</button>
         </div>
          </Form>
        
          
        </Card>
        <p className='drag-text'>Upload Resume</p>
         
          
       
        
        <div className='mt-5 d-flex text-center justify-content-center align-items-center mx-3'> 
        <Link to="/dashboard" className='next-button'>Complete
          </Link>
        </div>
       

      </Container>
   
    </Container>

    
  );
}

export default Form2;
